import qs from 'qs';
import axios from './axios'

export default function generateService(endpoint) {

    function search(data) {
        return axios.get(`${endpoint}/search`, { params: data, paramsSerializer: params => qs.stringify(params, { encodeValuesOnly: true })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        search
    }
}
